module.exports = __webpack_public_path__ + "static/black_rock-19e2fe9b32f8e97dfc6799ef2577ce6c.png";